import { FC } from 'react';
import { useCardSelector } from './useCardselector';
import { ICardAnalyticItemProps } from './types';
import { CardAnalyticRenderer } from './CardAnalyticRenderer';

interface ICardAnalyticProps {
  item: ICardAnalyticItemProps;
  isLoading: boolean;
  readOnly?: boolean;
  hasError?: boolean;
  // Card display variant: 'chart' for chart view, 'table' for table statistics view
  cardVariant?: 'chart' | 'table';
  // Table variant props
  filterCount?: number;
  filterValue?: string;
}

export const CardAnalytic: FC<ICardAnalyticProps> = ({ item, isLoading, readOnly, hasError, cardVariant, filterCount, filterValue }) => {
  const { id, unit } = item;
  const { checkIsEnable, checkIsActive, toggle } = useCardSelector();

  const isEnable = checkIsEnable(unit);
  const isActive = checkIsActive(id);

  if (readOnly) {
    return (
      <CardAnalyticRenderer
        item={item}
        isLoading={isLoading}
        readOnly={readOnly}
        isEnable={isEnable}
        isActive={isActive}
        hasError={hasError}
        cardVariant={cardVariant}
        filterCount={filterCount}
        filterValue={filterValue}
      />
    );
  }

  return (
    <button aria-label='card' type='button' onClick={() => toggle(id)} disabled={!isEnable} className='block w-full'>
      <CardAnalyticRenderer
        item={item}
        isLoading={isLoading}
        readOnly={readOnly}
        isEnable={isEnable}
        isActive={isActive}
        hasError={hasError}
        cardVariant={cardVariant}
        filterCount={filterCount}
        filterValue={filterValue}
      />
    </button>
  );
};
